import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import "./singleComic.scss";

const SingleComic = ({ data }) => {
    const { title, description, pageCount, thumbnail, languages, price } = data;

    useEffect(() => {
        document.title = `${title}`; // Явное обновление
        return () => {
            document.title = "";
        }; // Очистка при размонтировании
    }, []);

    return (
        <section className="singlecomic">
            <div className="singlecomic__wrapper">
                <Helmet>
                    <meta name="description" content={`${title} comics book`} />
                    <title>{title}</title>
                </Helmet>
                <img src={thumbnail} alt={title} className="singlecomic__img" />
                <div className="singlecomic__content">
                    <div className="singlecomic__content-title">
                        <h3 className="singlecomic__content-title-first">
                            {title}
                        </h3>
                        <Link
                            to="/comics"
                            className="singlecomic__content-title-second"
                        >
                            Back to all
                        </Link>
                    </div>
                    <p className="singlecomic__content-text">{description}</p>
                    <p className="singlecomic__content-page">{pageCount}</p>
                    <p className="singlecomic__content-language">
                        Language: {languages}
                    </p>
                    <p className="singlecomic__content-price">{price}$</p>
                </div>
            </div>
        </section>
    );
};

export default SingleComic;

//мое решение
// const SingleComic = () => {
//     const { comicId } = useParams(); //т.к. хук возвращает  объект {cimicId:56}, то этот ключ можно вытащить путем деструктуризации
//     const [comic, setComic] = useState(null);

//     const { error, loading, getComic, getComicByTitle, clearError } =
//         useMarvelService();

//     useEffect(() => {
//         upDateComic();
//     }, [comicId]);

//     const upDateComic = () => {
//         clearError(); //перед тем как делаем новый запрос убираем ошибку
//         getComic(comicId).then(onComicLoaded);
//     };

//     const onComicLoaded = (comic) => {
//         setComic(comic);
//     };
//     const errorMessage = error ? <ErrorMessage /> : null;
//     const spinner = loading ? <Spinner /> : null;
//     const content = !(loading || error || !comic) ? (
//         <View comic={comic} />
//     ) : null;

//     return (
//         <>
//             {errorMessage}
//             {spinner}
//             {content};
//         </>
//     );
// };

// const View = ({ comic }) => {
//     const { title, description, languages, pageCount, thumbnail, price } =
//         comic;
//     return (
//         <section className="singlecomic">
//             <div className="singlecomic__wrapper">
//                 <img src={thumbnail} alt={title} className="singlecomic__img" />
//                 <div className="singlecomic__content">
//                     <div className="singlecomic__content-title">
//                         <h3 className="singlecomic__content-title-first">
//                             {title}
//                         </h3>
//                         <Link
//                             to="/comics"
//                             className="singlecomic__content-title-second"
//                         >
//                             Back to all
//                         </Link>
//                     </div>
//                     <p className="singlecomic__content-text">{description}</p>
//                     <p className="singlecomic__content-page">{pageCount}</p>
//                     <p className="singlecomic__content-language">
//                         Language: {languages}
//                     </p>
//                     <p className="singlecomic__content-price">{price}$</p>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default SingleComic;
